import { render, staticRenderFns } from "./BudgetExpenditure.vue?vue&type=template&id=79f5bca2&scoped=true"
import script from "./BudgetExpenditure.vue?vue&type=script&lang=js"
export * from "./BudgetExpenditure.vue?vue&type=script&lang=js"
import style0 from "./BudgetExpenditure.vue?vue&type=style&index=0&id=79f5bca2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5bca2",
  null
  
)

export default component.exports